export default __webpack_public_path__ + "static/media/CoryCalawayWebDeveloperResume.23919e87.pdf";